/*jslint node: true*/
"use strict";


var ko = require("pli/knockout");
var pli = require("pli/forms");
var pliObservable = require("pli/forms-knockoutcontrols");

var dataCache = require("../datacache");
var entityRegistry = require("../entity-registry");
var picklistItemExtensions = require("../picklist-common/picklistItemViewModelExtensions");

require("../picklist-provincestate");

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// AreaViewModel
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function AreaViewModel(form) {
    this.initPicklistItem("Geo-Area-", form);

    this.name = this.id = pliObservable(null, null, "required");
    this.provinceState = pliObservable(null, entityRegistry.provinceState.getPicklistBehaviourData(), "picklist", "required");
    this.country = pliObservable(null, entityRegistry.country.getPicklistBehaviourData(), "picklist", "required");
    this.costCentre = pliObservable();

    this.extras.displayName = ko.computed(AreaViewModel.prototype._computeDisplayName, this);
}


//-------------------------------------------
AreaViewModel.prototype.fromCacheItem = function areaFromCacheItem(item) {
    var record;
    if (item && item.length) {
        record = {
            guid: item[item.length - 1],
            name: item[0],
            provinceState: item[1],
            country: item[2],
            costCentre: item[3]
        };
    } else {
        record = item;
    }
    return record;
};


//-------------------------------------------
AreaViewModel.prototype.load = function loadArea(record) {
    record = record || {};

    this.name.reset();
    this.provinceState.reset();
    this.country.reset();

    this.guid(record.guid || null);
    this.name.load(record.name);
    this.provinceState.load(record.provinceState);
    this.country.load(record.country);
    this.costCentre.load(record.costCentre);
};


//-------------------------------------------
AreaViewModel.prototype._computeDisplayName = function computeAreaDisplayName() {
    var id = this.id();
    return (id ? "Area ".concat(id) : "(No area name yet)");
};



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Initialization
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
var areaForm = pli.forms.registry.areaForm;

if (typeof areaForm !== "object") { throw new Error("Area form element could not be found - did you render it using CreateAreaForm?"); }
if (areaForm.viewModel) { throw new Error("Area form has already been initialized"); }

ko.utils.extend(AreaViewModel.prototype, picklistItemExtensions.mixins);
areaForm.viewModel = new AreaViewModel(areaForm);

entityRegistry.area.open.create = entityRegistry.area.open.edit = areaForm.viewModel.open;
entityRegistry.area.getPicklistBehaviourData = function getPicklistBehaviourData() {
    return {
        onNewItem: areaForm.viewModel.open,
        onOpenItem: areaForm.viewModel.open,
        picklistData: dataCache.getObservable("area")
    };
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
module.exports = AreaViewModel;



//////////////////
// WEBPACK FOOTER
// ./app/picklist-area/areaViewModel.js
// module id = 637
// module chunks = 49